






















import Vue from 'vue'
import Component from 'vue-class-component'

@Component({
  props: {
    type: {
      type: String,
      default: 'text'
    },
    id: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    rows: {
      type: Number,
      default: 4
    },
    validation: {
      type: String
    },
    inputStyle: {
      type: String,
      default: ''
    },
    error: {
      default: false,
      type: Boolean
    },
    size: {
      type: String,
      default: 'default'
    }
  }
})
export default class TextArea extends Vue {
  isError: boolean = false

  validateTextField (value: string) {
    this.isError = !value
  }

  emitInput (e: any) {
    this.$emit('input', e.target.value)
  }

  emit (eventName: string, e: any) {
    this.$emit(eventName, e)
    if (this.$props.validation) {
      this.validate(e.target.value)
    }
  }

  validate (value: string) {
    value = value || (this.$refs.inputRef as any).value
    switch (this.$props.validation) {
      case 'text':
        this.validateTextField(value)
        break
    }
  }
}
